// extracted by mini-css-extract-plugin
export default {"iag":"Settings_iag__ASM8x","iac":"Settings_iac__EL6qt"};